"use strict";

exports.__esModule = true;
exports.default = void 0;

var _loopStatus = _interopRequireDefault(require("../constants/loopStatus"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var MAX_MINS = 60;
var MIN_MINS = 0;

var loopAroundMinutes = function loopAroundMinutes(desiredInt) {
  if (desiredInt >= MAX_MINS) {
    return {
      value: desiredInt - MAX_MINS,
      status: _loopStatus.default.OVER
    };
  }

  if (desiredInt < MIN_MINS) {
    return {
      value: MAX_MINS + desiredInt,
      status: _loopStatus.default.UNDER
    };
  }

  return {
    value: desiredInt,
    status: _loopStatus.default.ASIS
  };
};

var _default = loopAroundMinutes;
exports.default = _default;